const updateRoomDetail = (query) => ({
    type: 'UPDATE_ROOM',
    id: 1,
    query: query
});

export { updateRoomDetail }
